<div class="qty" *ngIf="quantity > 1" matTooltip="Quantity">{{quantity}}</div>
<div class="card-img" [style.min-width]="width + 'px'" [style.min-height]="(width / 0.71) + 'px'" [ngClass]="{ 'card-img-hover': hoverable, 'card-img-clickable': clickable }"
     matRipple [matRippleDisabled]="!clickable">
    <img class="small-card" [ngClass]="{'invalid': !isValid(card), 'draggable': draggable}" [style.width]="width + 'px'"
         [src]="getImage()"
         alt="Image of {{card?.name}}"
         (click)="cardClicked.emit(card)" (contextmenu)="onCardContext($event, card)"/>
    <mat-icon class="flipper" *ngIf="flippable()" (click)="doTransform($event)" matTooltip="Flip">autorenew</mat-icon>
</div>
<img *cdkDragPreview class="card"
     [src]="getImage()"
     [ngClass]="{'draggable': draggable}"
     alt="Image of {{card?.name}}"/>
<div *cdkDragPlaceholder></div> <!-- this hides the placeholder in the receiving drop list -->
